<template>
    <div v-show="!item.isDeleted" class="item-container" @mouseover="mouseOver" @mouseleave="mouseLeave"
        @dblclick="itemDblClick" v-bind:style="{
            backgroundColor: item.isHovered ? ' #007bff' : '#77a7fd',
            flexDirection: item.isTooth ? 'column' : 'row'
        }">

        <div class="item-header">
            <img class="item-btn item-visible" v-on:click="isVisibleChanged()" title="Visible"
                :src="item.isVisible ? 'images/visible_on_white.png' : 'images/visible_off_white.png'" />
            <span class="item-color" ref="itemColor" :style="{ backgroundColor: item.color }"></span>
            <div class="an-name" :title="item.displayName">{{ item.displayName }}{{ item.isChanged ? " *" : "" }}
            </div>
            <img v-if="item.isTooth" :src="item.isChanged ? 'images/annotation_red.png' : 'images/annotation_white.png'"
                class="item-btn item-edit" v-on:click="editItemClick()" title="Edit" />

            <img v-if="!item.isTooth" :src="item.isOpen ? 'images/denture_red.png' : 'images/denture_white.png'"
                class="item-btn item-denture" v-on:click="openGingivaClick()" title="Opened Gingiva" />

            <img class="item-btn item-focus" v-on:click="focus()" title="Focus"
                :src="item.isFocused ? 'images/focus_red.png' : 'images/focus_white.png'" />
            <img v-if="item.isTooth" class="item-btn item-settings" v-on:click="editItemNumberClick()"
                title="Edit Number" :src="'images/gear_white_icon.png'" />
            <img v-if="item.isTooth" class="item-btn" v-on:click="remove()" title="Delete"
                :src="'images/trash_icon.png'" />

            <!-- <img v-if="!item.isTooth"
                :src="item.isFocused && item.isOriginal ? 'images/original_red.png' : 'images/original_white.png'"
                class="item-btn item-original" v-on:click="originalClick()" title="Original" /> -->

        </div>
    </div>
</template>

<script>
import swal from "sweetalert";
import {
    changeItemVisibility, deleteItem, editItemNumber, selectItem,
    highlightItem, unhighlightItem, switchItemFocus, checkIsEditMode,
    getModelByItem, setToothIsChanged, switchItemOpen, switchOriginalView
} from "../IntraoralManager";


export default {
    name: "IntraoralListItem",
    props: {
        item: {
            type: Object,
            required: true
        },
        viewMode: {
            type: Object,
            // required: true
        },
    },
    data() {
        return {
            isMouseOver: false
        };
    },
    watch: {
        "item.isHovered": {
            handler(newVal, oldVal) {
                if (newVal) {
                    highlightItem(this.item);
                    // if (!this.isMouseOver) {
                    //     this.$el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                    // }
                }
                else {
                    unhighlightItem(this.item);
                }
            }
        },
        "item.isClicked": {
            handler(newVal, oldVal) {
                if (newVal) {
                    if (!this.isMouseOver) {
                        this.$el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                    }
                    this.item.isClicked = false;
                }
            }
        },
    },
    methods: {
        openGingivaClick: async function () {
            this.item.isOpen = !this.item.isOpen;
            if (this.item.isOpen && this.item.isFocused) {
                this.item.isFocused = false;
            }
            await switchItemOpen(this.item);
        },
        originalClick: async function () {
            if (this.item.isFocused) {
                this.item.isOriginal = !this.item.isOriginal;
            }
            else {
                this.item.isOriginal = this.item.isFocused = true;
            }
            await switchItemFocus(this.item);
        },
        itemDblClick: function () {
            if (this.item.isTooth)
                selectItem(this.item);
        },
        editItemClick: function () {
            let tooth = getModelByItem(this.item);
            if (tooth) {
                let isChanged = !tooth.isChanged;
                setToothIsChanged(tooth, isChanged);
                if (isChanged) {
                    selectItem(this.item);
                }
            }
        },
        mouseOver: function () {
            this.isMouseOver = true;
            this.item.isHovered = true;

        },
        mouseLeave: function () {
            this.isMouseOver = false;
            this.item.isHovered = false;
        },
        editItemNumberClick: function () {
            if (!this.item.isTooth)
                return;
            editItemNumber(this.item);
        },
        isVisibleChanged: function () {
            this.item.isVisible = !this.item.isVisible;
            changeItemVisibility(this.item);
        },
        focus: async function () {
            this.item.isFocused = !this.item.isFocused;
            await switchItemFocus(this.item);
        },
        remove: function () {
            if (!this.item.isTooth)// || !checkIsEditMode())
                return;

            deleteItem(this.item);
        }
    }
}

</script>

<style scoped>
.item-container {
    color: white;
    padding: 0.2rem;
    border: solid white 0.1rem;
    display: flex;
    gap: 3px;
    /* flex-direction: column; */
}

.item-header {
    display: flex;
    align-items: stretch;
    gap: 5px;
    width: 100%;
}

.item-tools {
    display: flex;
    align-items: stretch;
    gap: 14px;
    margin-left: 3px;
}

.item-selected {
    display: block;
}

.item-color {
    margin-top: 2px;
    margin-left: 4px;
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
}

.item-download {
    margin-top: 3px;
    height: 20px;
    width: 20px;
    cursor: pointer;
    /* display: inline-block; */
}

.an-name {
    margin-top: 1px;
    white-space: nowrap;
    /* text-wrap: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    flex-grow: 1;
    max-width: calc(100% - 68px);
}

.item-btn {
    margin-top: 1px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.item-visible {
    margin-top: 0px;
    height: 25px;
    width: 25px;
}

.item-focus {
    margin-top: 0px;
    height: 23px;
    width: 23px;
}

.item-settings {
    margin-top: 2px;
}

.item-original {
    margin-top: 1px;
}

.item-denture {
    margin-top: 0;
}
</style>